import styled from 'styled-components';

export const PlayerWrapper = styled.div`
  display: flex;
  align-items: stretch;
  position: relative;

  .custom-fullscreen-content {
    position: absolute;
    top: 20%;
    left: 20%;
    width: 60%;
    height: 60%;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10; /* Ensure it's above other elements */
    pointer-events: none;
   }
`;


export const PlayerRef = styled.div`
  height: 100%;
  position: relative;

  video-js {
    height: 100%;
    border-radius: 4px;

    &.vjs-user-inactive {
      .vjs-text-track-display {
        bottom: 1px !important;
      }
    }

    @media screen and (max-width: 480px ) {
      .vjs-text-track-cue {
        height: 45px !important;
      }
    }

    @media screen and (max-width: 900px) and (orientation: landscape) {
      .vjs-text-track-cue  {
        height: 45px !important;
      }
    }

    .vjs-text-track-cue > * {
      border-radius: 4px !important;
      padding: 4px !important;
    }


    .vjs-custom-chapters-menu {
      position: absolute;
      top: -200px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      z-index: 999;
      padding: 10px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      visibility: visible;
      opacity: 1;
    }


  }
`

export const PlayerRefWrapper = styled.div`
  width: 100%;
`
